import { Navigate, useRoutes } from 'react-router-dom'
import { lazy } from 'react'
// layouts
import DefaultLayout from 'src/layouts/default/layout'
// config
import { mainRoutes } from './routes'
import { paths } from '../paths'

const Page404 = lazy(() => import('src/pages/404'))
const Page403 = lazy(() => import('src/pages/403'))

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <DefaultLayout>
          <Navigate to={paths.app.dashboard} replace />
        </DefaultLayout>
      ),
    },

    ...mainRoutes,

    // No match 404
    { path: '*', element: <Page404 /> },

    // 403
    { path: '403', element: <Page403 /> },
  ])
}
